import { getApiActionTypes } from '../storeHelpers';

export const fetchAccountAuditTrailsTypes = getApiActionTypes('FETCH_ACCOUNT_AUDIT_TRAILS');
export const fetchAccountDataTypes = getApiActionTypes('FETCH_ACCOUNT_DATA');
export const fetchAccountAdjustmentTypes = getApiActionTypes('FETCH_ACCOUNT_ADJUSTMENT');
export const fetchCalcDataTypes = getApiActionTypes('FETCH_CALC_DATA');
